import React from 'react';
import { RouterContext } from '../../contexts/RouterContext';
import { useContextSelector } from 'use-context-selector';
import styled from 'styled-components';
import { ArrowLeft } from '../Icons/ArrowLeft';
import { useMainRouter } from '../../Router/pageComponents';

export const Horizontal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* align-items: center; */
`;

const DivBack = styled.div`
  margin-right: 16px;
  cursor: pointer;
  margin-top: 3px;

  img {
    max-width: 24px;
  }
`;

type BackIconProps = {
  goBack?: () => void;
};

export const BackIcon = ({ goBack }: BackIconProps) => {
  const { goBack: localRouterGoBack } = useContextSelector(RouterContext, state => state);
  const { goBack: mainRouterGoBack, history } = useMainRouter();

  function handleGoBack() {
    if (goBack) return goBack();

    if (history.length > 1) mainRouterGoBack();
    else localRouterGoBack();
  }

  return (
    <DivBack data-testid="test-return" onClick={() => handleGoBack()}>
      <ArrowLeft />
    </DivBack>
  );
};
